export const environment = {
    production: false,
    api: 'https://sponsor-api.nitrocnct.com',
    // api: 'http://localhost:8081',
};
